// components/Banner.js
import React from "react";
import "../App.css"; // Optional for styling

const Banner = ({ bannerImage, title }) => {
  return (
    <div className="banner" style={{ backgroundImage: `url(${bannerImage})` }}>
      <h1 className="banner-title">{title}</h1>
    </div>
  );
};

export default Banner;
